import {ListCategories} from './list-categories';

export default ListCategories;
